import React, { createContext } from 'react'
import { ApplicationProvider } from '../../contexts/ApplicationContext'

export const MetricsContext = createContext({ state: {} })

export const MetricsProvider = (props) => {
  const contextValue = {
    trackingDetails: constructTrackingDetails(props)
  }
  return (
    <ApplicationProvider value={contextValue}>
      <MetricsContext.Provider value={{ state: props }}>
        {props.children}
      </MetricsContext.Provider>
    </ApplicationProvider>
  )
}

const constructTrackingDetails = ({ userDetails }) => (
  {
    user: userDetails.user
  }
)
